.editor-header__container {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  max-width: calc(100% - 5rem);
}

.editor-header__info {
  color: var(--color-grey-700);
  font-size: var(--font-size-text-non-essential);
}
